import React, { useState, useEffect } from 'react';

const ContactForm = ({ contact, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    profileImage: '',
    email: '',
    location: '',
    github: '',
    linkedin: '',
    thailandPhone: '',
    myanmarPhone: '',
    viber: '',
    whatsapp: '',
    lineId: '',
    twitter: ''
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (contact) {
      setFormData(contact);
    }
  }, [contact]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }

    if (!formData.location.trim()) {
      newErrors.location = 'Location is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      onSave(formData);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxHeight: '70vh', overflowY: 'auto', paddingRight: '10px' }}>
      <h3>{contact ? 'Edit Contact Information' : 'Add Contact Information'}</h3>

      <div className="form-group">
        <label htmlFor="profileImage">👤 Profile Image</label>
        <input
          id="profileImage"
          type="url"
          name="profileImage"
          value={formData.profileImage}
          onChange={handleChange}
          placeholder="https://example.com/profile.jpg"
        />
        {formData.profileImage && (
          <div style={{ marginTop: '10px', textAlign: 'center' }}>
            <img 
              src={formData.profileImage} 
              alt="Profile" 
              style={{ width: '100px', height: '100px', borderRadius: '50%', objectFit: 'cover', border: '3px solid #2196F3' }}
              onError={(e) => {
                e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect fill="%23ccc" width="100" height="100"/%3E%3Ctext x="50%" y="50%" text-anchor="middle" dy=".3em" fill="%23999" font-size="14"%3EInvalid URL%3C/text%3E%3C/svg%3E';
              }}
            />
          </div>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="email">📧 Email *</label>
        <input
          id="email"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="your@email.com"
        />
        {errors.email && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.email}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="location">📍 Location *</label>
        <input
          id="location"
          type="text"
          name="location"
          value={formData.location}
          onChange={handleChange}
          placeholder="City, Country"
        />
        {errors.location && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.location}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="github">🔗 GitHub</label>
        <input
          id="github"
          type="url"
          name="github"
          value={formData.github}
          onChange={handleChange}
          placeholder="https://github.com/yourname"
        />
      </div>

      <div className="form-group">
        <label htmlFor="linkedin">💼 LinkedIn</label>
        <input
          id="linkedin"
          type="url"
          name="linkedin"
          value={formData.linkedin}
          onChange={handleChange}
          placeholder="https://linkedin.com/in/yourname"
        />
      </div>

      <div className="form-group">
        <label htmlFor="twitter">🐦 Twitter</label>
        <input
          id="twitter"
          type="url"
          name="twitter"
          value={formData.twitter}
          onChange={handleChange}
          placeholder="https://twitter.com/yourname"
        />
      </div>

      <div className="form-group">
        <label htmlFor="thailandPhone">🇹🇭 Thailand Phone</label>
        <input
          id="thailandPhone"
          type="tel"
          name="thailandPhone"
          value={formData.thailandPhone}
          onChange={handleChange}
          placeholder="+66 8 XXXX XXXX"
        />
      </div>

      <div className="form-group">
        <label htmlFor="myanmarPhone">🇲🇲 Myanmar Phone</label>
        <input
          id="myanmarPhone"
          type="tel"
          name="myanmarPhone"
          value={formData.myanmarPhone}
          onChange={handleChange}
          placeholder="+95 9 XXXX XXXX"
        />
      </div>

      <div className="form-group">
        <label htmlFor="viber">📱 Viber</label>
        <input
          id="viber"
          type="tel"
          name="viber"
          value={formData.viber}
          onChange={handleChange}
          placeholder="+66 8 XXXX XXXX"
        />
      </div>

      <div className="form-group">
        <label htmlFor="whatsapp">💬 WhatsApp</label>
        <input
          id="whatsapp"
          type="tel"
          name="whatsapp"
          value={formData.whatsapp}
          onChange={handleChange}
          placeholder="+66 8 XXXX XXXX"
        />
      </div>

      <div className="form-group">
        <label htmlFor="lineId">📲 Line ID</label>
        <input
          id="lineId"
          type="text"
          name="lineId"
          value={formData.lineId}
          onChange={handleChange}
          placeholder="your_line_id"
        />
      </div>

      <div className="modal-actions">
        <button type="button" className="cancel-btn" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="save-btn">
          {contact ? 'Update Contact' : 'Create Contact'}
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
